import { CardLinkFormValues } from '@/types/cardLink';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { useFormikContext } from 'formik';
import { useEffect, useRef, useState } from 'react';

export const IconEmojiPicker = () => {
  const { values, setFieldValue } = useFormikContext<CardLinkFormValues>();
  const [showPicker, setShowPicker] = useState(false);
  const emojiButtonRef = useRef<HTMLButtonElement>(null);
  // Detect emoji: if icon is a single unicode emoji, use it, else fallback
  const emoji =
    typeof values.icon === 'string' && values.icon.match(/^\p{Emoji}$/u)
      ? values.icon
      : '😊';

  // Close picker on Escape
  useEffect(() => {
    if (!showPicker) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setShowPicker(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showPicker]);

  return (
    <div className="mb-4 flex flex-col">
      <button
        type="button"
        ref={emojiButtonRef}
        className="mb-2 size-16 cursor-pointer rounded-[15px] bg-gray-100 text-4xl shadow-md"
        style={{ lineHeight: 1 }}
        aria-label="Pick emoji"
        onClick={() => setShowPicker(show => !show)}
      >
        {emoji}
      </button>
      {showPicker && (
        <>
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
            onClick={() => setShowPicker(false)}
            tabIndex={-1}
            aria-label="Close emoji picker"
          >
            {/* Prevent click from closing when clicking inside Picker */}
            <div className="relative" onClick={e => e.stopPropagation()}>
              <Picker
                data={data}
                theme="light"
                onEmojiSelect={(e: { native: string }) => {
                  setFieldValue('icon', e.native);
                  setShowPicker(false);
                }}
                className="rounded-lg bg-white shadow-xl"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
